import "./AboutUs.scss";

import AboutUsImg from "../../assets/images/about-us.png";
import Button from "../../components/shared/Button";

import { useEffect, useState, useCallback, useRef } from "react";

import paper from "paper";
import { pathToRelativeClipPath } from "../../utils/pathConverter";
import AboutBg from "../../assets/images/about-bg.webm";

// Helper function to round the corners of a path to a given radius
function roundPath(path, radius) {
	const segments = [...path.segments];
	path.removeSegments();

	for (let i = 0; i < segments.length; i++) {
		const curPoint = segments[i].point;
		const nextPoint = segments[(i + 1) % segments.length].point;
		const prevPoint =
			segments[(i - 1 + segments.length) % segments.length].point;

		const nextDelta = curPoint.subtract(nextPoint);
		const prevDelta = curPoint.subtract(prevPoint);

		nextDelta.length = radius;
		prevDelta.length = radius;

		path.add({
			point: curPoint.subtract(prevDelta),
			handleOut: prevDelta.divide(2),
		});

		path.add({
			point: curPoint.subtract(nextDelta),
			handleIn: nextDelta.divide(2),
		});
	}

	path.closed = true;
	return path;
}

// this function is used to calculate the SVG data for the clip path
function calculateSvgData(statsBg) {
	const screenWidth = window.innerWidth;

	// width and height of the statsBg element
	const bg_width = statsBg.clientWidth;
	const bg_height = statsBg.clientHeight;

	var clip_width = 200;
	var clip_height = 73;

	if (screenWidth <= 768) {
		clip_width = 155;
		clip_height = 53;
	}

	// Create a Paper.js project
	const project = new paper.Project();

	// Create the main rectangle
	const rect1 = new paper.Path.Rectangle({
		point: [0, 0],
		size: [bg_width, bg_height],
	});

	// Create the smaller rectangle to subtract
	const rect2 = new paper.Path.Rectangle({
		/* point: [900, 112],
		size: [140, 130], */
		point: [bg_width - clip_width, bg_height - clip_height],
		size: [clip_width, clip_height],
	});

	// Subtract the smaller rectangle
	let subtractedShape = rect1.subtract(rect2);

	// Remove the original rectangles
	rect1.remove();
	rect2.remove();

	// Round the corners
	var radius = 30;

	if (screenWidth <= 768) {
		radius = 20;
	}

	subtractedShape = roundPath(subtractedShape, radius);

	// Export the path as SVG
	const svg = subtractedShape.exportSVG({ asString: false });

	let pathString = svg.getAttribute("d");

	return pathToRelativeClipPath(pathString);
}

export default function AboutUs() {
	const statsBgRef = useRef(null);
	const [svgData, setSvgData] = useState("");

	const updateSvgData = useCallback(() => {
		const newSvgData = calculateSvgData(statsBgRef.current); // Assuming this returns a string like "M0.026,1 C0.013,1,0,0.918..."
		setSvgData(newSvgData);
	}, []);

	useEffect(() => {
		// Initial calculation on mount
		updateSvgData();

		// Add resize listener
		window.addEventListener("resize", updateSvgData);

		// Cleanup listener on unmount
		return () => window.removeEventListener("resize", updateSvgData);
	}, [updateSvgData]); // Dependency array ensures the effect runs when updateSvgData changes

	return (
		<>
			<div className="about-us" id="about-us">
				<div className="decoration about-us-light-1"></div>

				<div className="about-us-content-wrapper content-wrapper-lg">
					<div className="about-us-stats">
						<div className="about-us-stats-bg" ref={statsBgRef}>
							<svg className="svg" width="0" height="0">
								<clipPath
									id="my-clip-path"
									clipPathUnits="objectBoundingBox"
									// No need to set width and height here, they are not used with objectBoundingBox
								>
									<path d={svgData}></path>
								</clipPath>
							</svg>

							{/* <video
								autoPlay
								loop
								muted
								className="about-us-stats-bg"
							>
								<source src={AboutBg} type="video/webm" />
							</video> */}
							<img className="about-us-stats-bg" src={AboutUsImg} alt="About Us"/>
						</div>

						<Button
							className="about-us-btn"
							href="https://aur-ai.gitbook.io/aurai"
						>
							Learn More
						</Button>

						{/* <div className="about-us-stats-content">
							<span className="stats-item users-stats">
								+23K User
							</span>

							<span className="stats-item revenue-stats">
								+1.4B Monthly turnover
							</span>
						</div> */}
					</div>

					<div className="about-us-content">
						<h1 className="about-us-title">About Us</h1>

						<p className="about-us-desc desc-1">
							AurAI uses advanced AI to simplify and enhance the
							decentralized world. By blending blockchain
							transparency with AI insights, we empower users to
							make smarter decisions and optimize strategies
							<span className="mobile-more-text">
								focused on DeFi and trading, AurAI delivers
								tools for trade optimization, risk management,
								and opportunity discovery - all while
								prioritizing security and decentralization.
							</span>
						</p>

						<p className="about-us-desc desc-2">
							Focused on DeFi and trading, AurAI delivers tools
							for trade optimization, risk management, and
							opportunity discovery - all while prioritizing
							security and decentralization.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
